import React from 'react';

import {
  ContentGroup,
  Heading,
  Link,
  List,
  ListItem,
  Main,
  Paragraph,
} from '@constellation/core';
import { useContent } from '@interstellar/react-app-content';
import { StyledLink } from 'client/components/styledLink/StyledLink';
import Helmet from 'react-helmet';

import { ProfessionalLandlordHelpContent } from './ProfessionalLandlordHelpPage.config';
import * as routes from '../manifest';

function ProfessionalLandlordHelpPage() {
  const {
    metaContent,
    backLabel,
    title,
    whenYoureALandlord,
    lettingAgents,
    accountants,
    solicitors,
  } = useContent<ProfessionalLandlordHelpContent>();

  return (
    <Main>
      <Helmet>
        <title>{metaContent.title}</title>
      </Helmet>
      <ContentGroup marginTop="05" marginBottom="none">
        <StyledLink
          iconPosition="left"
          data-testid="back-button-link"
          to={routes.LandlordSupport}
        >
          {backLabel}
        </StyledLink>
      </ContentGroup>
      <Heading as="h1" size="s7" marginTop="05">
        {title}
      </Heading>
      <Paragraph>{whenYoureALandlord}</Paragraph>

      <Heading as="h2">{lettingAgents.title}</Heading>
      <Paragraph>{lettingAgents.lotsOfLandlords}</Paragraph>
      <Paragraph>{lettingAgents.beforeYouChoose}</Paragraph>
      <Paragraph>
        {lettingAgents.allAgents}
        <Link
          data-testid="redress-scheme-link"
          href={lettingAgents.redressLinkHref}
          external
        >
          {lettingAgents.redressLinkLabel}
        </Link>
        {lettingAgents.andA}
        <Link
          data-testid="client-money-protection-link"
          href={lettingAgents.clientMoneyLinkHref}
          external
        >
          {lettingAgents.clientMoneyLinkLabel}
        </Link>
        {lettingAgents.period}
      </Paragraph>
      <Paragraph>
        <Link
          data-testid="check-if-agent-is-registered-link"
          href={lettingAgents.checkIfRegisteredLinkHref}
          external
        >
          {lettingAgents.checkIfRegisteredLinkLabel}
        </Link>
      </Paragraph>
      <Paragraph>
        {lettingAgents.agentsInScotland}
        <Link
          data-testid="scottish-letting-agent-register-link"
          href={lettingAgents.scottishAgentRegisterLinkHref}
          external
        >
          {lettingAgents.scottishAgentRegisterLinkLabel}
        </Link>
        {lettingAgents.period}
      </Paragraph>
      <Paragraph>
        {lettingAgents.northernIreland}
        <Link
          data-testid="agents-must-be-registered-link"
          href={lettingAgents.agentsMustBeRegisteredLinkHref}
          external
        >
          {lettingAgents.agentsMustBeRegisteredLinkLabel}
        </Link>
        {lettingAgents.partOfRedressScheme}
      </Paragraph>

      <Heading as="h2">{accountants.title}</Heading>
      <Paragraph>{accountants.havingAnAccountant}</Paragraph>
      <Paragraph>{accountants.askAround}</Paragraph>
      <Paragraph>{accountants.noOfficialBody}</Paragraph>
      <Heading as="h3" size="s3">
        {accountants.charteredAccountantsTitle}
      </Heading>
      <List>
        {accountants.charteredAccountantsListItems.map((item) => (
          // Get the last word in each entry as its unique
          <ListItem key={item.split(' ').at(-1)}>{item}</ListItem>
        ))}
      </List>

      <Heading as="h2">{solicitors.title}</Heading>
      <Paragraph>{solicitors.beingALandlord}</Paragraph>
      <Paragraph>
        <Link
          data-testid="find-a-solicitor-england-wales-link"
          href={solicitors.findSolicitorEnglandLinkHref}
          external
        >
          {solicitors.findSolicitorEnglandLinkLabel}
        </Link>
      </Paragraph>
      <Paragraph>
        <Link
          data-testid="find-a-solicitor-scotland-link"
          href={solicitors.findSolicitorScotlandLinkHref}
          external
        >
          {solicitors.findSolicitorScotalndLinkLabel}
        </Link>
      </Paragraph>
      <Paragraph>
        <Link
          data-testid="find-a-solicitor-northern-ireland-link"
          href={solicitors.findSolicitorNorthernIrelandLinkHref}
          external
        >
          {solicitors.findSolicitorNortherIrelandLinkLabel}
        </Link>
      </Paragraph>
    </Main>
  );
}

export default ProfessionalLandlordHelpPage;
